import {api} from '@/api';
import utils from 'utils';

import {useNavigate} from 'react-router-dom';
import {useQueryClient} from '@tanstack/react-query';

import {useLabel} from '@/hooks/export';

export const MainMenu = (props: {
    onClick: () => void,
}) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const label = useLabel();

    return <div className={cmpClass} onClick={() => props.onClick()}>
        <div className={classMap.container + ' container'}>
            <a onClick={() => navigate('/catalog')}>Produkty</a>
            <a onClick={() => navigate('/wiki/obchodni-oddeleni')}>Kontakty</a>
            <a onClick={() => navigate('/machine-request')}>Dopyt</a>
        </div>
        <div className={classMap.divider + ' container'}>
            <hr />
        </div>
        <div className={classMap.container + ' container'}>
            <a onClick={() => navigate('/profile')}>{label.myAccount}</a>
            <a onClick={() => navigate('/orders')}>{label.myOrders}</a>
            <a onClick={() => {
                api.user.logout()
                    .then(() => queryClient.invalidateQueries({queryKey: ['user']}));
            }}>
                Odhlásiť sa
            </a>
        </div>
    </div>;
};

const cmpClass = 'main-menu';

const classMap = utils.generateClassMap(cmpClass, {
    container: 'container',
    divider: 'divider',
});
